import React from 'react';
import debounce from 'lodash/debounce';

import { Helpers } from '../core/src/helpers';
import Dropdown from '../shared/components/dropdown';

export default class GiftCardForm extends React.Component{

    state = {
        itemId: "",
        fromName: "",
        toName: "",
        recipientEmail: "",
        confirmEmail: "",
        "message": "",
        "type": "",
        touched: {},
        "addMessage": false,
        price: 0
    }

    static getDerivedStateFromProps(props, state){
        if(state.type !== props.type){
            return {
             type: props.type
            }   
        }
        return null;
    }

    hasErrors = () =>{
        const {
            itemId,
            fromName,
            toName,
            recipientEmail,
            confirmEmail,
            message,
            type,
        } = this.state;
        const isVirtual = type.toLowerCase() === 'vgc';

        return {
            itemId: !itemId || itemId === "",
            fromName: fromName === "" || !Helpers.isAlphaNumeric(fromName),
            toName: toName === "" || !Helpers.isAlphaNumeric(toName),
            recipientEmail: isVirtual && !Helpers.validateEmail(recipientEmail),
            confirmEmail: isVirtual && (!Helpers.validateEmail(confirmEmail) || confirmEmail !== recipientEmail),
        }
    }

    toggleMessage = () => {
        const addMessage = !this.state.addMessage;
        this.setState({
            addMessage,
            message: addMessage ? this.state.message : ""
        });
    }

    handleBlur = (event) => {
        const { target } = event;
        const { name } = target;

        this.setState({
          touched: { ...this.state.touched, [name]: true },
        });
    }

    //debounce handle change to avoid 
    //rerender spam from typing
    updateParent = debounce(() => {
        const errors = this.hasErrors();
        const hasErrors = Object.keys(errors).reduce((r, k) =>  r || errors[k],false)
        const form = {
            itemId: this.state.itemId,
            fromName: this.state.fromName,
            toName: this.state.toName,
            recipientEmail: this.state.recipientEmail,
            confirmEmail: this.state.confirmEmail,
            "message": this.state.message,
            "type": this.state.type,
            "isGC": true,
            "price": this.state.price
        }

        this.props.handleChange(form, hasErrors);
    },300);

    handleChange = (event) => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;

        this.setState({
          [name]: value
        }, this.updateParent);
    }

    handleAmountSelect = (index) =>{
        this.setState({
          itemId: this.props.items[index].itemId,
          price: this.props.items[index].salePrice
        }, this.updateParent);
    }

    errorClassName = (errors, field) => {
        const hasError = errors[field];
        const shouldShow = this.props.validate || this.state.touched[field];
        return hasError && shouldShow ? " error" : "";
    }

    render(){
       const { items, type="" } = this.props;
       const isVirtual = type.toLowerCase() === 'vgc';
       const errors = this.hasErrors();
       const { addMessage } = this.state;

       return (
             <form className="gift-card-form">
                <div className="row">
                    <span  className={"col-3 " + this.errorClassName(errors,"itemId")}>
                        <label>
                          Amount: 
                        </label>
                        <Dropdown options={items} displayKey={'salePrice'} selectOption={this.handleAmountSelect}/>
                    </span>
                    <span className={"col-3 " + this.errorClassName(errors,"fromName")}>
                        <label>
                        From:
                        </label>
                        <input
                        placeholder="Your Name"
                        name="fromName"
                        type="text"
                        value={this.state.fromName}
                        onChange={this.handleChange}
                        onBlur={this.handleBlur} />
                    </span>
                    <span className={"col-3 " + this.errorClassName(errors,"toName")}>
                        <label>
                          To:
                        </label>
                          <input
                            placeholder="Recipient's name"
                            name="toName"
                            type="text"
                            value={this.state.toName}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur} />
                    </span>
                </div>
                { isVirtual ?
                    <div className="row virtual-giftcard">
                        <span className={"col-6 " + this.errorClassName(errors,"recipientEmail")}>
                            <label>
                              Recipient Email:
                            </label>
                              <input
                                name="recipientEmail"
                                type="email"
                                value={this.state.recipientEmail}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur} />
                        </span>
                        <span  className={"col-6 " + this.errorClassName(errors,"confirmEmail")}>
                            <label>
                              Confirm Email:
                            </label>
                              <input
                                name="confirmEmail"
                                type="email"
                                value={this.state.confirmEmail}
                                onChange={this.handleChange}
                                onBlur={this.handleBlur} />
                        </span>
                        <span className="form-note">Note: email provided here will only be used to deliver your e-Gift Card.</span>
                    </div>
                    : null
                }
                <div className="show-more" onClick={this.toggleMessage}>Add a personalized message</div>
                {
                    addMessage ?
                    <div className="row">
                        <span className="col-12">
                        <label>Message (Optional)</label>
                            <textarea name="message" maxLength="500" onChange={this.handleChange}>
                                {this.state.message}
                            </textarea>
                            <span className="form-note">Max 500 characters</span>
                        </span>
                    </div>
                    :null
                }
            </form>
        );
    }
}
